import { userSchema } from '../../users/models';

export const user = () => {
  return {
    endpoint: `/auth/user`,
    method: 'GET',
    responseSchema: userSchema,
  } as const;
};
